import { render, staticRenderFns } from "./RemplacementAlertsModal.vue?vue&type=template&id=625b3ec2"
import script from "./RemplacementAlertsModal.vue?vue&type=script&lang=ts"
export * from "./RemplacementAlertsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports